import * as React from 'react';

export const AdvCake = () => {
  return (
    <>
      <script
        id="advcakeAsync"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            '(function(a) {\n' +
            '    var b = a.createElement("script");\n' +
            '    b.async = 1;\n' +
            '    b.src = "//code.5dhnv8.ru/";\n' +
            '    a = a.getElementsByTagName("script")[0];\n' +
            '    a.parentNode.insertBefore(b, a)\n' +
            '  })(document);',
        }}
      ></script>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            'window.advcake_data = window.advcake_data || [];\n' +
            '    window.advcake_data.push({\n' +
            '        pageType: 2,\n' +
            '        user: {\n' +
            "            email: ''\n" +
            '        }\n' +
            '    });',
        }}
      ></script>
    </>
  );
};
